import { atom } from 'recoil';
import type { ArgumentId } from '../../components/UpdateAction/components/ConditionEditorV2/types';

const activeSelectorState = atom<ArgumentId | null>({
  key: 'activeSelector',
  default: null,
});

export default activeSelectorState;
